import { createSlice } from '@reduxjs/toolkit';

const FJAddSocialSlice = createSlice({
    name: 'FJAddSocialSlice',
    initialState: {
        isShow: false,
    },
    reducers: {
        setIsShow(state, action) {
            state.isShow = action.payload;
        },
    },
});

export default FJAddSocialSlice;
